import api from './api';

const recommendationService = {
  alsoBought: (productId, limit = 6) =>
    api.get(`/recommendations/also-bought/${productId}`, { params: { limit } }),
  similar: (productId, limit = 6) =>
    api.get(`/recommendations/similar/${productId}`, { params: { limit } }),
  trending: (limit = 8, category = '') =>
    api.get('/recommendations/trending', { params: { limit, category } }),
  forYou: (viewedProductIds = [], limit = 8) =>
    api.post('/recommendations/for-you', { viewedProductIds, limit }),
};

export default recommendationService;
